import { render, staticRenderFns } from "./inflationRate.vue?vue&type=template&id=192bc59e&scoped=true"
import script from "./inflationRate.vue?vue&type=script&lang=js"
export * from "./inflationRate.vue?vue&type=script&lang=js"
import style0 from "./inflationRate.vue?vue&type=style&index=0&id=192bc59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192bc59e",
  null
  
)

export default component.exports